import React from 'react';
import './Header.css'; // Opcional: si el header tiene sus propios estilos

const HeaderTotal = ({ total }) => {
  return (
    <div className="header-container">
      <div className="resumen-compra">
        <div>
          <p className="titulo-resumen">Resumen de compra</p>
          <p className="pedido-express">Pedido express</p>
        </div>
        <p className="total">{total}</p>
      </div>
    </div>
  );
};

export default HeaderTotal;